import type { SessionProviderStateBundle } from "./use-session-provider-state-bundle";
import { useSessionDetailCache } from "./use-session-detail-cache";
import { useSessionLiveSignals } from "./use-session-live-signals";
import { useSessionReadTracking } from "./use-session-read-tracking";
import { useSessionTimestamps } from "./use-session-timestamps";

export interface SessionProviderLiveWiring {
  readTracking: ReturnType<typeof useSessionReadTracking>;
  liveSignals: ReturnType<typeof useSessionLiveSignals>;
  detailCache: ReturnType<typeof useSessionDetailCache>;
  timestamps: ReturnType<typeof useSessionTimestamps>;
}

export function useSessionProviderLiveWiring(input: {
  userId: string | null;
  state: SessionProviderStateBundle;
}): SessionProviderLiveWiring {
  const { state, userId } = input;
  const readTracking = useSessionReadTracking({
    currentUserId: userId,
    products: state.entity.products,
    chatMessages: state.conversation.chatMessages,
    chatMessageIds: state.conversation.chatMessageIds,
    collabs: state.conversation.collabs,
    collabsByProduct: state.conversation.collabsByProduct,
  });
  const ownMessageIdsRef = readTracking.ownMessageIdsRef;
  const liveSignals = useSessionLiveSignals({
    products: state.entity.products,
    productsRef: state.refs.productsRef,
    membersRef: state.refs.membersRef,
    rootProductIdRef: state.refs.rootProductIdRef,
    ownMessageIdsRef,
    setProducts: state.entity.setProducts,
  });
  const detailCache = useSessionDetailCache({
    setProductDetailsById: state.entity.setProductDetailsById,
    setVersionDetailsById: state.entity.setVersionDetailsById,
  });
  const timestamps = useSessionTimestamps();

  return {
    readTracking,
    liveSignals,
    detailCache,
    timestamps,
  };
}
